"use strict";

exports.__esModule = true;
exports.default = void 0;

var componentStyleReset = function componentStyleReset(theme) {
  return {
    boxSizing: 'border-box',
    color: theme.color,
    fontFamily: theme.fontFamily ? theme.fontFamily + ", " + theme.fontFamily_system : "" + theme.fontFamily_system,
    fontSize: theme.fontSize_base,
    lineHeight: theme.lineHeight,
    outline: 0,
    '& *,& *::before,& *::after': {
      boxSizing: 'inherit'
    },
    MozOsxFontSmoothing: 'auto',
    WebkitFontSmoothing: 'antialiased'
  };
};

var _default = componentStyleReset;
exports.default = _default;